import PureGameElement    from '../../tools/PureGameElement';
import { filter, remove } from 'lodash';

const eventType = {
    SWIPE_LEFT: 'SWIPE_LEFT',
    SWIPE_RIGHT: 'SWIPE_RIGHT',
    KEY_RIGHT: 'KEY_RIGHT',
    KEY_LEFT: 'KEY_LEFT',
    CLICK_RIGHT: 'CLICK_RIGHT',
    CLICK_LEFT: 'CLICK_LEFT',
};


class InputManager extends PureGameElement {
    constructor ( scene ) {
        super( scene );
        this.handlersList = [];
        this.initialX = null;
        this.initialY = null;

        this._addEventsListeners();
    }

    _addEventsListeners () {
        document.addEventListener( 'touchstart', ( e ) => {
            this.initialX = e.touches[0].clientX;
            this.initialY = e.touches[0].clientY;
            if ( this.initialX < window.innerWidth / 2 ) {
                this._triggerHandler( eventType.CLICK_LEFT, e );
            } else {
                this._triggerHandler( eventType.CLICK_RIGHT, e );
            }

        }, false );

        document.addEventListener( 'touchmove', ( e ) => {
            if ( this.initialX === null || this.initialY === null ) return;

            let currentX = e.touches[0].clientX;
            let currentY = e.touches[0].clientY;

            let diffX = this.initialX - currentX;
            let diffY = this.initialY - currentY;

            if ( Math.abs( diffX ) > Math.abs( diffY ) ) {
                // sliding horizontally
                if ( diffX > 0 ) {
                    this._triggerHandler( eventType.SWIPE_LEFT, e );
                } else {
                    this._triggerHandler( eventType.SWIPE_RIGHT, e );
                }
            } else {
                // sliding vertically
                if ( diffY > 0 ) {
                    // swiped up
                } else {
                    // swiped down
                }
            }
            this.initialX = null;
            this.initialY = null;
        }, false );

        document.addEventListener( 'keydown', ( e ) => {
            const keynum = e.keyCode || e.which;
            if ( keynum === 39 ) { //right
                this._triggerHandler( eventType.KEY_RIGHT, e );
            }
            if ( keynum === 37 ) { //left
                this._triggerHandler( eventType.KEY_LEFT, e );
            }
        }, false );


        document.body.addEventListener( 'click', ( e ) => {
            const clickX = e.clientX;
            if ( clickX < window.innerWidth / 2 ) {
                this._triggerHandler( eventType.CLICK_LEFT, e );
            } else {
                this._triggerHandler( eventType.CLICK_RIGHT, e );
            }
        }, false );
    }

    _addHandler ( eventName, handler ) {
        this.handlersList.push( {
            event: eventName,
            handler
        } );
        return () => this.removeHandler( handler );
    }

    _triggerHandler ( eventName, event ) {
        filter( this.handlersList, { event: eventName } )
            .forEach( ( { handler } ) => {
                if ( typeof handler === 'function' )
                    handler( event );
            } );
    }

    removeHandler ( handler ) {
        remove( this.handlersList, { handler } );
    }

    onSwipeLeft ( handler ) {
        return this._addHandler( eventType.SWIPE_LEFT, handler );
    }

    onSwipeRight ( handler ) {
        return this._addHandler( eventType.SWIPE_RIGHT, handler );
    }

    onKeyLeft ( handler ) {
        return this._addHandler( eventType.KEY_LEFT, handler );
    }

    onKeyRight ( handler ) {
        return this._addHandler( eventType.KEY_RIGHT, handler );
    }

    onClickLeft ( handler ) {
        return this._addHandler( eventType.CLICK_LEFT, handler );
    }

    onClickRight ( handler ) {
        return this._addHandler( eventType.CLICK_RIGHT, handler );
    }

}

export default InputManager;
